import { drawerActions, manutencaoActions, listagemActions, dadosPdvActions, listaTabelaDadosActions, listaSelectPaginadoActions, parametrosEmpresaActions,  } from '../actions'

export const reducer = (state, action) => {
    switch (action.type) {
        case drawerActions.CHANGE:
            return {
                ...state,
                ui: action.data
            };

        case manutencaoActions.CHANGE:
            return {
                ...state,
                manutencao: action.data
            };

        case listagemActions.CHANGE:
            return {
                ...state,
                listagem: { ...state.listagem, ...action.data }
            };

        case dadosPdvActions.CHANGE:
            return {
                ...state,
                dadosPdv: action.data
            };

        case listaTabelaDadosActions.CHANGE:
            return {
                ...state,
                listaTabelaDados: action.data
            };

        case listaSelectPaginadoActions.CHANGE:
            return {
                ...state,
                listaSelectPaginado: action.data
            };

        case parametrosEmpresaActions.CHANGE:
            return {
                ...state,
                parametrosEmpresa: { ...state.parametrosEmpresa, ...action.data }
            };

        default:
            return state;
    }
};